import { CommonHttpService } from './CommonHttpService';
import { URL_CONSTANT } from '../constants/UrlConstant';

export const RouteService = {
    RouteList : () => {
        return CommonHttpService.httpGet(URL_CONSTANT.RouteList);
    }
}